import { render, staticRenderFns } from "./ServiceableAttributeEditor.vue?vue&type=template&id=42c548df&scoped=true"
import script from "./ServiceableAttributeEditor.vue?vue&type=script&lang=js"
export * from "./ServiceableAttributeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c548df",
  null
  
)

export default component.exports